import React, { useEffect, useState, useContext } from 'react'
import * as m5 from '@mobiscroll/react5'
import Nav from './Nav'
import BigNumber from "bignumber.js"
import { db } from '../index'
import { styleNumber, numberWithCommas, getTimestamp } from '../Helper'
import { AppPopover } from './Config';
import { AppContext } from '../Launcher'
import dividendInfo from '../dataset/dividend.json'
import moment from 'moment'
import { NOTIFICATION_COLOR } from './Stock'
import MemoEditor from './MemoEditor'

const MAX_FREE_MEMO = 5

export const sortTrans = (a, b) => {
    if (b.date === a.date) {
        return (b.ut - a.ut)
    } else {
        if (b.date > a.date) {
            return 1
        } else {
            return -1
        }
    }
}

const ArchiveTitle = ({ close }) => {
    return (
        <div className='bg-warning p-1'>
            <div className={'d-flex justify-content-between mx-2 text-black'}>
                <h5>紀錄封存</h5>
                <button type="button" className="close" aria-label="Close" onClick={close}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className={'mx-2 text-muted'}>已封存紀錄的損益將不列入首頁計算</div>
        </div>
    )
}

const ExternalSites = ({ stockNo, memo, memoAllowed, saveMemo }) => {

    const [memoIsOpen, setMemoIsOpen] = useState(false)
    const [alert, setAlert] = useState(null)

    const openMemo = () => {
        if (memoAllowed)
            setMemoIsOpen(true)
        else
            setAlert('因伺服器儲存成本\n至多備註5檔股票 🙏🏻\n加入VIP解除限制！')
    }
    const closeMemo = () => setMemoIsOpen(false)

    const save = (str) => {
        saveMemo(stockNo, str)
        closeMemo()
    }

    const btnColor = memo && memo.length > 0 ? "btn-info" : "btn-secondary"

    return (
        <>
            <div className="mx-2 text-muted">股票資訊網站</div>
            <div className="d-flex justify-content-between m-2">
                {/* <a rel="noreferrer" className="btn btn-sm btn-light mx-1" href={'https://www.cmoney.tw/finance/f00025.aspx?s=' + stockNo} target="_blank">
                    CMoney
                </a> */}
                <div>
                    <a rel="noreferrer" className="btn btn-sm btn-light mx-1" href={'https://goodinfo.tw/tw/StockDetail.asp?STOCK_ID=' + stockNo} target="_blank">
                        GoodInfo!
                    </a>
                    <a rel="noreferrer" className="btn btn-sm btn-light mx-1" href={'https://tw.stock.yahoo.com/q/ta?s=' + stockNo} target="_blank">
                        Yahoo!
                    </a>
                </div>
                {/* <a rel="noreferrer" className="btn btn-sm btn-light mx-1" href={'https://histock.tw/stock/' + stockNo} target="_blank">
                    HiStock
                </a>
                <a rel="noreferrer" className="btn btn-sm btn-light mx-1" href={'https://www.wantgoo.com/stock/' + stockNo} target="_blank">
                    玩股網
                </a> */}
                <div>
                    <button className={'btn btn-sm ' + btnColor + ' mx-1'} onClick={openMemo}>個股備註</button>
                    <AppPopover text={alert} onSet={() => { setAlert(null) }} />
                    <MemoEditor isOpen={memoIsOpen} memo={memo} onCancel={closeMemo} onSave={save} />
                </div>
            </div>
        </>
    )
}

const HEIGHT_AD = 0 //4.5 //rem
const ArchiveConfirmPopover = ({ text, onConfirm, onCancel }) => {
    let content = text
    if (text != null && text.indexOf('\n') > -1) {
        content = text.split('\n').map((t, i) => (
            <div key={'acp-' + i}>{t}</div>
        ))
    }
    return (
        <m5.Popup
            isOpen={text !== null}
            buttons={[{
                text: '取消',
                handler: onCancel
            }, {
                text: '封存',
                handler: onConfirm,
                cssClass: 'text-danger'
            }]}>
            {content}
        </m5.Popup>
    )
}


const History = ({ user, stockNo, pz, y, title, transactions, setTransaction, onClose, afterArchive, memoList, setMemoList }) => {

    const { appContext } = useContext(AppContext)
    const { theme, vip } = appContext

    let dividendDay = ''
    if (vip) {
        const dInfo = dividendInfo.filter(d => d.id === stockNo)
        if (dInfo.length > 0) {
            const day = moment(dInfo[0].date).startOf('day').diff(moment().startOf('day'), 'day')
            if (day > -1 && day < 8)
                dividendDay = day === 0 ? '今天除' + dInfo[0].type : day + '天後除' + dInfo[0].type
        }
    }
    const tableCls = theme === 'dark' ? 'table-dark' : ''
    const bg = theme === 'dark' ? 'bg-dark' : 'bg-white'
    const txt = theme === 'dark' ? 'text-light' : 'text-dark'
    const border = theme === 'dark' ? 'border-light' : 'border-dark'
    //const fillBg = theme === 'dark' ? '#000000' : '#efeff4'


    const name = transactions.length > 0 ? transactions[0].name : ''
    const mkt = transactions.length > 0 ? transactions[0].mkt : ''
    const p = styleNumber(new BigNumber(pz - y).toNumber())
    const [archiveMode, setArchiveMode] = useState(false)
    const [archiveTxt, setArchiveTxt] = useState(null)
    const [selected, setSelected] = useState([])
    const [alert, setAlert] = useState(null)

    useEffect(() => {
        if (transactions.length === 0) {
            onClose()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [transactions])

    const onClickRow = (d) => {
        if (archiveMode) {
            let newSelected = [...selected]
            const idx = newSelected.indexOf(d._id)
            if (idx === -1) {
                newSelected.push(d._id)
            } else {
                newSelected.splice(idx, 1)
            }
            setSelected(newSelected)
        } else
            setTransaction(d)
    }

    const selectAll = (ev) => {
        let newSelected = []
        if (ev.target.checked) {
            newSelected = transactions.map(t => t._id)
        }
        setSelected(newSelected)
    }

    const addTransaction = () => {
        setTransaction({
            id: stockNo,
            name,
            mkt
        })
    }

    let income = 0
    let expense = 0

    transactions.forEach(d => {
        let fee = d.cfee ? d.cfee : d.cfee === 0 ? 0 : d.fee
        switch (d.action) {
            case 'sell':
                income += d.amount - fee
                break
            case 'profit':
                income += d.amount
                break
            default:
                expense += d.amount + fee
                break
        }
    })

    const enterArchiveMode = () => [
        setArchiveMode(true)
    ]

    const leaveArchiveMode = () => {
        setArchiveMode(false)
    }

    const archive = () => {
        if (selected.length > 0)
            setArchiveTxt('您確定要封存 ' + stockNo + ' ' + name + '\n已選擇的交易紀錄？')
        else
            setAlert('尚未選擇任何紀錄')
    }

    const cancelArchive = () => [
        setArchiveTxt(null)
    ]

    const doArchive = () => {
        const batch = db.batch();
        selected.forEach(id => {
            batch.update(db.collection("transactions").doc(id), { archive: 1, ut: getTimestamp() })
        })
        batch.commit().then(() => {
            setArchiveTxt(null)
            afterArchive(user, 'cache')
        })
    }
    const memoArr = memoList.filter(({ id }) => id === stockNo)
    let memo = ''
    if (memoArr.length > 0) {
        memo = memoArr[0].memo
    }

    const saveMemo = (id, memo) => {
        let list = [...memoList]
        const idx = list.findIndex(m => m.id === id)
        if (idx < 0) {
            list.push({ id, memo })
        } else {
            list.splice(idx, 1, { id, memo })
        }
        setMemoList(list)
    }

    return (
        <>
            <Nav theme={theme} title={title} onBack={onClose} menu={(theme) => {
                return (
                    <div className="dropdown">
                        <button className="btn btn-online-secondary border-0" type="button" data-toggle="dropdown" aria-expanded="false">
                            <i className="bi bi-three-dots-vertical" style={{ color: theme === 'dark' ? '#fff' : '#000' }}></i>
                        </button>
                        <div className="dropdown-menu" style={{ backgroundColor: theme === 'dark' ? '#000' : '#fff' }}>
                            <button className={"dropdown-item"} style={{ backgroundColor: theme === 'dark' ? '#000' : '#fff', color: theme === 'dark' ? '#fff' : '#000' }} type="button" onClick={enterArchiveMode}>封存</button>
                        </div>
                    </div>
                )
            }} />
            <AppPopover text={alert} onSet={() => { setAlert(null) }} />
            <ArchiveConfirmPopover text={archiveTxt} onCancel={cancelArchive} onConfirm={doArchive} />
            <div style={{ position: 'relative' }}>
                <div className={'w-100 py-2 ' + bg} style={{ position: 'sticky', top: '3.5rem', display: 'table' }}>
                    <div className="mx-2 d-flex justify-content-start">
                        <div className={'h4 ' + txt} style={{ maxWidth: '50%' }}>{stockNo} {name}</div>
                        <div className={'ml-2 ' + p.color} style={{ lineHeight: '2rem' }}>
                            {p.v >= 0 ? '▲ ' + p.v.toFixed(2) : '▼ ' + p.v.toFixed(2).replace('-', '')}
                            {'(' + (p.v / y * 100).toFixed(2).replace('-', '') + '%)'}
                        </div>
                    </div>
                    <div className={'mx-2 d-flex justify-content-between ' + txt}>
                        {dividendDay ?
                            <button className="btn rounded-lg px-2 py-0" style={{ color: NOTIFICATION_COLOR, border: '1px solid' + NOTIFICATION_COLOR }}>{dividendDay}</button>
                            : <div></div>
                        }
                        <div className={'rounded-lg border ' + border}>
                            <span className="mx-2">累計支出 {numberWithCommas(expense)}</span>
                            <span className="mx-2">已實收入 {numberWithCommas(income)}</span>
                        </div>
                    </div>
                </div>
                {archiveMode ? <ArchiveTitle close={leaveArchiveMode} /> :
                    <ExternalSites stockNo={stockNo} memo={memo} memoAllowed={vip || memoList.filter(m => m.id !== stockNo && m.memo).length < MAX_FREE_MEMO} saveMemo={saveMemo} />}
                <table className={'mt-2 table table-striped ' + tableCls}>
                    <tbody>
                        {
                            transactions.sort(sortTrans).map(d => {
                                let action = ''
                                let amount = ''
                                let fee = d.cfee ? d.cfee : d.cfee === 0 ? 0 : d.fee
                                let credit = ''
                                if (d.credit)
                                    credit = d.creditType === 'short' ? '券' : '資'
                                switch (d.action) {
                                    case 'sell':
                                        action = <span className="text-success ml-1">{credit}賣</span>
                                        amount = <span className="text-success ml-1">收入{numberWithCommas(d.amount - fee)}</span>
                                        break;
                                    case 'profit':
                                        const profitTxt = {
                                            profit: "股利",
                                            reduction: "減資",
                                            lending: "借券",
                                        }[d.profitType] || "股利";
                                        action = <span className="text-primary ml-1">{profitTxt}</span>
                                        amount = <span className="text-primary ml-1">收入{numberWithCommas(d.amount)}</span>
                                        break;
                                    default:
                                        action = <span className="text-danger ml-1">{credit}買</span>
                                        amount = <span className="text-danger ml-1">支出{numberWithCommas(d.amount + fee)}</span>
                                        break;
                                }
                                
                                return (
                                    <tr key={d._id}>
                                        <td className={'d-flex justify-content-between w-100 ' + txt} onClick={() => {
                                            onClickRow(d)
                                        }}>
                                            {d.date}
                                            {action}
                                            <span className="ml-1 ">{d.quantity}股</span>
                                            <span className="ml-1 ">價格{d.price}</span>
                                            {amount}
                                            {archiveMode && <label className="sb-checkbox">
                                                <input type="checkbox" checked={selected.indexOf(d._id) > -1} onClick={() => {
                                                    onClickRow(d)
                                                }
                                                } />
                                                <span></span>
                                            </label>
                                            }
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        <tr>
                            <td className={'d-flex justify-content-end w-100 ' + txt} style={{ minHeight: '8rem' }}>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
            {archiveMode ?
                <div className={'fixed-bottom ' + txt + ' ' + bg}>
                    <div className='d-flex justify-content-end pr-2 my-1'>
                        <span className='mx-2'>全選</span>
                        <label className="sb-checkbox">
                            <input type="checkbox" checked={selected.length === transactions.length} onClick={selectAll} />
                            <span style={{ minHeight: '1.5rem' }}></span>
                        </label>
                    </div>
                    <div className='d-flex justify-content-between p-1'>
                        <button type="button" className="btn btn-secondary rounded-pill w-50 m-2 py-2"
                            onClick={leaveArchiveMode}>
                            取消
                        </button>
                        <button type="button" className="btn btn-danger rounded-pill w-50 m-2 py-2"
                            onClick={archive}>
                            封存
                        </button>
                    </div>
                </div> :
                <div className="fixed-bottom d-flex justify-content-end" style={{ marginBottom: HEIGHT_AD + 'rem' }}>
                    <button className="btn shadow rounded-circle bg-danger mb-4 mr-4 p-0"
                        style={{ width: '3rem', height: '3rem', fontSize: '1.5rem' }}
                        onClick={addTransaction}>
                        <svg xmlns="http://www.w3.org/2000/svg"
                            width="3rem" height="3rem" fill="currentColor" className="bi bi-plus text-white" viewBox="0 0 16 16">
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                        </svg>
                    </button>
                </div>
            }
        </>
    )
}

export default History